import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { HStack } from "@/components/ui/hstack";
import React, { useEffect, useState } from 'react';
import { studioVersion } from "../../algorithms_and_functions/studioVersion";
import { IconM } from '@/components/media/IconsV2';
import i18n from 'i18n-js';
import { switchScreen } from '@/hooks/navigate';

export default function ContactHeader({ navigation, route, options }) {
  const [exit_title, setExitTitle] = useState();

  useEffect(() => {
    switch (route.name) {
      case 'ViewContact':
        setExitTitle(i18n.t('studio.contact.exit'));
        break;
      case 'ViewChannel':
        setExitTitle(i18n.t('studio.channel.exit'));
        break;
    }
  }, []);

  return (
    <HStack space='xs' className="shadow-hard-3justify-between items-center bg-secondary-50 h-[74px] px-6">
      <Pressable onPress={() => {
        // ---
        // FIXME(@Milo): `goBack` will not work without history if subpage is opened directly.
        if (!navigation.canGoBack()) {
          switchScreen(navigation, 'Studio', {})
        } else {
          navigation.goBack()
        }
        // ---
      }}>
        <HStack space='md' className="items-center">
          <IconM className='text-secondary-900' name='keyboard-arrow-left' />
          <Text className="text-secondary-900 text-md">{exit_title}</Text>
        </HStack>
      </Pressable>
    </HStack>
  );
}
